import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-tsp-profile',
    templateUrl: './tsp-profile.component.html',
    styleUrls: ['./tsp-profile.component.css'],
    standalone: false
})
export class TspProfileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
